import config from '../data/config.json';
import dict from '../data/dictionary.json';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import noUiSlider from 'nouislider';

import { Sesion, Datos, cargarURL, obtenerURL } from '../main.js';
import { filtroTaxonesTemplate, coloresTemplate, taxonesSubheadingTemplate, sugeTaxonesTemplate, 
	taxonesBlockTemplate, taxonModalTemplate, filterPlotModalTemplate, footerFilterPlot } from '../data/htmlTemplates.js';
import { getLiteral, uriToLiteral, firstUppercase, indexOfNormalized, configurarModal } from './util.js';
import { renderEntradaLugares } from './places.js';
import { ajustarColorProvincias, ajustarPopupsProvincias } from './provinces.js';
import { ajustarColorTeselas, ajustarPopupsTeselas } from './patches.js';
import { ajustarColorParcelas, ajustarPopupsParcelas } from './plots.js';
import { ajustarColorArboles, ajustarPopupsArboles } from './trees.js';
import { sendEvent } from './events.js';

//////////////////////////////
// FUNCIONES ÚTILES DE TAXONES
function getMoreSpecificTaxon(types) {
	if (!types)
		return undefined;
	// inicializaciones
	let suri = undefined;
	let nexpuris = null;
	// convierto en array si hace falta
	let arsp = Array.isArray(types)? types : [ types ];
	// evalúo cada uno de los tipos disponibles
	for (let evtype of arsp) {
		if (Datos.taxones[evtype] != undefined && Datos.taxones[evtype].expuris != undefined) {
			// aquí tengo uno válido, miro si es mejor que lo que tenía
			if (nexpuris == null || Datos.taxones[evtype].expuris.length < nexpuris) {
				suri = evtype;
				nexpuris = Datos.taxones[evtype].expuris.length;
			}
		}	
	}
	// devuelvo suri
	return suri;
} 
function sumMeasureTaxon(measure, tx) { // lo usaré sólo en parcelas
	// obtengo medida por taxón
	let sum = 0;
	if (measure) {
		const alltx = Object.keys(measure); // obtengo los taxones de la parcela o provincia
		for (let evtx of alltx) {
			if (tx === config.treeUri) // en caso de árbol genérico, siempre adentro
				sum += measure[evtx];
			else {
				// compruebo si está contenida evtx en la lista de especies expandida de tx
				if (Datos.taxones[tx].expuris.includes(evtx) )
					sum += measure[evtx];
			}	
		}
		// dos decimales
		sum = Number(sum.toFixed(2));
	}
	return sum;
}
function sumPropInfoTaxon(infosar, prop, txuri) { // lo usaré sólo en provincias
	// obtengo suma de valores de prop para el taxón txuri en el conjunto de infoSpecies
	let sum = 0;
	// analizo cada objeto infoEspecies para hacer el conteo
	for (let is of infosar) {
		// si hay algo en la propiedad continúo
		if (is[prop]) {
			// sumo si coincide con la especie
			if (txuri === config.treeUri) // en caso de árbol genérico, siempre adentro
				sum += getLiteral(is[prop]);
			else {
				if (is.species) {
					// compruebo si la especie del elemento infoEspecies está en la lista de especies expandida de spuri
					if (Datos.taxones[txuri].expuris.includes(is.species))
						sum += getLiteral(is[prop]);
				}
			}
		}
	}
	return sum;
}

////////////////////////////
// HANDLER NOMBRE CIENTÍFICO
function handlerNombreCientifico() {
	// guardo valor (en memoria y en local storage para recordarlo entre sesiones)
	Sesion.nomci = this.checked;
	localStorage.setItem('nomci', Sesion.nomci); // guardará "true" o "false"
	
	// 	nombres científicos o no
	sendEvent( 'select_content', { content_type: 'scientific_names_' + Sesion.nomci } );
		
	// etiquetas filtros de taxón (panel del mapa)
	visualizarFiltrosTaxon();
		
	// navegador taxones: cambio las etiquetas de todas las especies en la lista
	document.querySelectorAll(".taxones_block [spuri]").forEach(function(element) {
		// obtengo la especie
		const spuri= element.getAttribute("spuri");
		// nombre vulgar y científico
		const nvul = getTaxonLabel(spuri, false);
		const ncie = getTaxonLabel(spuri, true, true);
		// hago reemplazo en el markup del botón
		const oldmarkup = element.innerHTML;
		const newmarkup = Sesion.nomci? oldmarkup.replace(nvul, ncie) : oldmarkup.replace(ncie, nvul);
		element.innerHTML = newmarkup;
	});
	
	// entrada taxones: regenero sugerencias con un evento de tipo 'search'
	if (document.getElementById("in_taxon")) {
		const entrada = document.getElementById("in_taxon").value;
		if (entrada.length > 0) {
			const searchEvent = new Event('search', {}); 
			document.getElementById("in_taxon").dispatchEvent(searchEvent);
		}
	}
	
	// en teselas actualizo los popups (sólo monte)
	ajustarPopupsTeselas(Object.keys(Sesion.tesPintadas, false));
	
	// en parcelas actualizo los popups
	ajustarPopupsParcelas(Object.keys(Sesion.parPintadas));
	
	// en árboles actualizo los popups
	ajustarPopupsArboles(Object.keys(Sesion.parcarbPintadas));
	
	// en provincias actualizo los popups
	ajustarPopupsProvincias();
	
	// y cargo la URL (para las páginas no mapa)
	if (Sesion.estado.path !== "map") {		
		// actualizo botón del mapa
		document.getElementById("mapchecknomci").checked = Sesion.nomci;	
		cargarURL();
	}
}


////////////////////////////////
// VISUALIZACIÓN FILTRO TAXÓN (modo mapa)
// se llama desde cargarURL y desde handlerNombreCientifico
////////////////////////////////
function visualizarFiltrosTaxon() {
	if (Sesion.taxones.length == 0) {
		// escondo los filtros de taxón
		document.getElementById('filtros_taxon').classList.add("d-none");
		// etiqueta plantae
		document.getElementById("lab_plantae").innerHTML = Sesion.nomci? '<i>Plantae</i>' : getLiteral(dict.plants);
		// muestro plantae
		document.getElementById('plantae').classList.remove("d-none");
	} else {	
		// escondo plantae
		document.getElementById('plantae').classList.add("d-none");
		// preparo array con taxones filtrados
		let txfilts = [];
		const colsactivos = Sesion.taxonesColores.slice(0, Sesion.taxones.length);
		for (let ind=0; ind<Sesion.taxones.length; ind++) {
			const tx = Sesion.taxones[ind];
			const label = getTaxonLabel(tx, Sesion.nomci, true);
			// incluyo colores posibles
			let colores = [];
			const colsno = colsactivos.filter(c => c !== Sesion.taxonesColores[ind]);
			const cols = config.coltxinds.filter(c => !colsno.includes(c));
			for (let cind of cols)
				colores.push( {"cind": cind, "label": getLiteral(dict["color"+cind])} );
			const txobj = {
				ind: ind,
				turi: tx,
				textoFiltroTaxon: getLiteral(dict.filtering) +' <strong>' + label + '</strong>',
				color: config.colores[Sesion.taxonesColores[ind]][1],
				colores: colores,
				info: Datos.taxones[tx].wikidata? true : false,
				noplots: !Sesion.estado.plots, // nuevo				
				filterUnset: !Sesion.taxonesFiltros[tx] // nuevo
			};
			txfilts.push(txobj);
		}
		// hago visible el contenido
		const content = Mustache.render(filtroTaxonesTemplate, txfilts);
		document.getElementById('filtros_taxon').innerHTML = content;
		document.getElementById('filtros_taxon').classList.remove('d-none');
		
		// pongo handlers
		// ajustar filtro de taxón a las parcelas
		document.querySelectorAll('.tune_filter_taxon').forEach(el => {
			el.addEventListener('click', handlerAjustarFiltroTaxon);
		});
		// quitar filtro de taxón
		document.querySelectorAll('.quitar_taxon').forEach(el => {
			el.addEventListener('click', function () {
				console.time("quitar taxón");
				
				// escondo el filtro de taxón (aunque se eliminará en visualizarFiltrosTaxon)
				this.closest('.div_filtro_taxon').classList.add("d-none");	
				
				// cojo el índice
				const ind = Number(this.getAttribute('ind'));	
										
				// mando evento de quitar filtro de taxón a GA
				sendEvent( 'deselect_content', { content_type: 'taxon_filter', content_id: Sesion.taxones[ind] } );	
				
				// quito los ajustes del filtro de taxón
				delete Sesion.taxonesFiltros[Sesion.taxones[ind]];
				// elimino el taxón 
				Sesion.taxones.splice(ind, 1);
				Sesion.taxonesCorrExpuris.splice(ind, 1);
				// reajusto colores
				const col = Sesion.taxonesColores[ind]; // recupero el color
				Sesion.taxonesColores.splice(ind, 1); // lo borro de la posición en que estaba
				Sesion.taxonesColores.splice(Sesion.taxones.length, 0, col); // lo coloco justo después
				//Sesion.taxonesColores.push(col);
			
				// reajusto URL, pero no la cargo
				history.replaceState(Sesion.estado, "", obtenerURL());
				//cargarURL();
				
				// actualización colores y popups parcelas
				const puris = Object.keys(Sesion.parPintadas);
				ajustarColorParcelas(puris);
				ajustarPopupsParcelas(puris);
			
				// actualización colores y popups árboles
				const pauris = Object.keys(Sesion.parcarbPintadas);
				ajustarColorArboles(pauris);
				ajustarPopupsArboles(pauris);
				
				// actualización colores y popups provincias
				ajustarColorProvincias();
				ajustarPopupsProvincias();
				
				// actualización colores y popups teselas forestales
				const turis = Object.keys(Sesion.tesPintadas);
				ajustarColorTeselas(turis, false);
				ajustarPopupsTeselas(turis, false);
				
				// visualización filtros de taxón
				visualizarFiltrosTaxon();
				
				console.timeEnd("quitar taxón");
			});
		});
		
		// cambio color del filtro de taxón
		document.querySelectorAll('.color_taxon').forEach(el => {
			el.addEventListener('click', function (ev) {
				// si no pongo esto irá a cargarURL (!)
				ev.preventDefault();
				
				console.time("ajuste color taxón");
				
				// cojo el índice
				const mind = Number(this.getAttribute('ind'));
				// cojo el índice del color
				const cind = Number(this.getAttribute('cind'));
				// reajusto colores
				Sesion.taxonesColores[mind] = cind; // cambio
				for (let i=0; i<Sesion.taxonesColores.length; i++) {
					if (i!=mind && Sesion.taxonesColores[i]==cind) {
						// cambio el color, no puede repetirse
						const otroc = config.coltxinds.find(c => !Sesion.taxonesColores.includes(c));
						Sesion.taxonesColores[i] = otroc;						
					}
				}
				// cambio el color del filtro de taxón
				this.closest('.div_filtro_taxon').style.backgroundColor = config.colores[cind][1];
			
				// actualizo colores teselas
				const turis = Object.keys(Sesion.tesPintadas);
				ajustarColorTeselas(turis, false);
			
				// actualizo colores parcelas			
				const puris = Object.keys(Sesion.parPintadas);
				ajustarColorParcelas(puris);
			
				// actualizo colores árboles
				const pauris = Object.keys(Sesion.parcarbPintadas);
				ajustarColorArboles(pauris);				
			
				// actualizo colores provincias			
				ajustarColorProvincias();
			
				// actualizo colores posibles
				const colsactivos = Sesion.taxonesColores.slice(0, Sesion.taxones.length);
				for (let ind=0; ind<Sesion.taxones.length; ind++) {
					const ulColores = document.getElementById("ul_colores" + ind);
					const colsno = colsactivos.filter(c => c !== Sesion.taxonesColores[ind]);
					const cols = config.coltxinds.filter(c => !colsno.includes(c));
					for (let i = 0; i < cols.length; i++) {
						const cind = cols[i];
						// preparo etiqueta
						const clab = getLiteral(dict['color' + cind]);
                        // obtengo el anchor a actualizar
                        const mia = ulColores.querySelector("li:nth-child(" + (i + 1) + ") a");
                        // actualizo cind y la etiqueta
                        mia.setAttribute('cind', cind);
                        mia.innerHTML = clab;
                    }
				}
				
				console.timeEnd("ajuste color taxón");
			});
		});
	}
	// info taxón (de Wikidata)
	document.querySelectorAll('.info_taxon').forEach(el => {
		el.addEventListener('click', mostrarInfoTaxon);
	});
}
function mostrarInfoTaxon() {
	// obtengo uri del taxón
	const turi = this.getAttribute("turi");

	// objeto taxón
	const taxon = Datos.taxones[turi];
	// preparo objeto del popover
	let popobj = {};
	
	/* PREVIO
	// imagen
	if (taxon.wikidata.image) {
		popobj.hayimagen = true;
		let imgsaux = Array.isArray(taxon.wikidata.image)? taxon.wikidata.image : [ taxon.wikidata.image ];
		popobj.image = [];
		let first = true;
		for (let img of imgsaux) {
			// ajusto tamaño para que tarde menos en recuperarla
			const imgsrc = (img.startsWith('http://commons.wikimedia.org/wiki/Special:FilePath') && img.indexOf('?') === -1 )?
				img + "?width=300" : img;
			popobj.image.push( { src: imgsrc, active: first})
			first = false;
		}
		if (popobj.image.length == 1)
			popobj.image = popobj.image[0].src;
		else
			popobj.multimages = true;
	}
	// resumen
	if (taxon.wikidata.comment)
		popobj.resumen = getLiteral(taxon.wikidata.comment);
	
	// wikidataPage
	if (taxon.wikidata)
		popobj.wikidataPage = taxon.wikidata.iri;
	// wikipediaPage
	if (taxon.wikidata && taxon.wikidata.wikipediaPage)
		popobj.wikipediaPage = taxon.wikidata.wikipediaPage;
	// wikispeciesPage
	if (taxon.wikidata && taxon.wikidata.wikispeciesPage)
		popobj.wikispeciesPage = taxon.wikidata.wikispeciesPage;
	// gbifPage
	if (taxon.wikidata && taxon.wikidata.gbifPage)
		popobj.gbifPage = taxon.wikidata.gbifPage;*/	
	
	// imagen
	if (taxon.images.length > 0) {
		popobj.hayimagen = true;
		if (taxon.images.length == 1)
			popobj.image = taxon.images[0];
		else {
			popobj.multimages = true;			
			const randomIndex = Math.floor(Math.random() * taxon.images.length);
			popobj.image = taxon.images.map((img, index) => {
				return { src: img, active: index === randomIndex };
			});
		}
	}
	// resumen
	if (taxon.extract)
		popobj.resumen = getLiteral(taxon.extract);
	// wikidataPage
	if (taxon.wikidata)
		popobj.wikidataPage = taxon.wikidata;
	// wikipediaPage
	if (taxon.wikipedia)
		popobj.wikipediaPage = getLiteral(taxon.wikipedia);
	// wikispeciesPage
	if (taxon.wikispecies)
		popobj.wikispeciesPage = taxon.wikispecies;
	// gbifPage
	if (taxon.gbif)
		popobj.gbifPage = taxon.gbif;
		
	// indico tipo: especie, género, familia, clase o agrupación de taxones
	if (taxon.isClass)
		popobj.tipo = getLiteral(dict.class);
	else if (taxon.isFamily)
		popobj.tipo = getLiteral(dict.family);
	else if (taxon.isGenus)
		popobj.tipo = getLiteral(dict.genus);
	else if (taxon.isSpecies)
		popobj.tipo = getLiteral(dict.species);
	else if (taxon.isTaxonSet)
		popobj.tipo = getLiteral(dict.taxonSet);

	// preparo contenido modal
	let tit = getTaxonLabel(turi, true, true);
	let htmlcontent = Mustache.render(taxonModalTemplate, popobj);
	configurarModal( { lg: true, nofooter: true }, 
		tit, htmlcontent, null);
	// muestro modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();
				
	// mando evento de info taxón a GA		
	sendEvent( 'select_content', { content_type: 'info_taxon', content_id: turi } );
}


//////////////////////////
// HANDLER FILTRAR TAXÓN (modo mapa)
function handlerFiltrarTaxon() {
	// obtengo nuevo estado del botón
	const activar = !document.getElementById("bot_taxones").classList.contains("active");
		
	// pongo el botón activo o no
	if (activar)
		document.getElementById("bot_taxones").classList.add("active");
	else 
		document.getElementById("bot_taxones").classList.remove("active");
	
	// render de la selección de taxón
	renderSeleccionTaxon(activar);
}

//////////////////////////
// RENDER SELECCIÓN TAXÓN
function renderSeleccionTaxon(activar) {
	// RENDER ENTRADA LUGARES (para que no interfiera)
	renderEntradaLugares(!activar);
	// BLOQUEO/DESBLOQUEO DEL RADIO DE LOS IFNs (lista de taxones se actualizará)
	for (let ifn of config.ifnVersions)  {
    	const elifn = document.getElementById(ifn);
	    if (elifn)
			elifn.disabled = activar;
	}
	
	// selecciono los divs apropiados según el modo
	const divbus = document.getElementById("taxones_subheading");
	const divnav = document.getElementById("taxones_block");

	// BÚSQUEDA CON ENTRADA DE TEXTO Y SUGERENCIAS DE TAXONES
	if (activar) {
		// rendering del subheading
		const content = Mustache.render(taxonesSubheadingTemplate, {'activar': activar} );
		divbus.innerHTML = content;
		divbus.classList.remove("d-none");

		// handler de buscar taxon...
		document.getElementById("in_taxon").addEventListener('keyup', handleTaxonInput);
		document.getElementById("in_taxon").addEventListener('search', handleTaxonInput);
		function handleTaxonInput(e) {
			// Get the suggestions container
		    const sugecont = document.getElementById('sugetaxones');
			//console.log("Caracter: " + e.which);
			// trato las teclas de arriba, abajo y enter			
			if (e.which == 13) { // tecla ENTER
				// array de sugerencias
				const enabledsuges = Array.from(sugecont.children).filter(child => !child.disabled);
				// actúo según el focus
				if (Sesion.txfocus == -1)	{ // ninguna sugerencia seleccionada
					// si hay al menos una sugerencia (y habilitada) voy a la primera
					if (enabledsuges.length > 0)
						enabledsuges[0].click();
				}
				else // obtengo la sugerencia y vamos a ella
					enabledsuges[Sesion.txfocus].click();
			}
			else if (e.which == 40) { // tecla ABAJO
				// incremento focus
				Sesion.txfocus++;
				ajustarTaxonfocus();
			}
			else if (e.which == 38) { // tecla ARRIBA
				// decremento focus
				Sesion.txfocus--;
				ajustarTaxonfocus();
			}
			else { // caso normal
				const entrada = document.getElementById("in_taxon").value;
				// analizo la cadena de entrada
				if (entrada.length < 1) { // está vacía: muestro la taxonomía y elimino las sugerencias
					divnav.classList.remove("d-none");
					sugecont.innerHTML = "";
				}
				else {	// hay algo: muestro sugerencias y escondo la taxonomía
					divnav.classList.add("d-none");
					// obtengo sugerencias de tipos de sitios
					const suges = sugeTaxones(entrada);
					// renderizo las sugerencias
					renderSugeTaxones(entrada, suges);
				}
			}
		}
	} 
	else
		divbus.classList.add("d-none");
	
	// NAVEGACIÓN ONTOLOGÍA DE TIPOS
	if (activar) { // mostrar el bloque de contenido de las especies
		divnav.classList.remove("d-none");
		// ¿caso inicial?
		if (divnav.innerHTML === "") {
			// preparo datos para mostrar
			let btaxainfo = [];
		
			// analizo los taxones top
			for (const spuri of config.taxonesTop) {
				// obtengo información del objeto para formatear
				let spinfo = getInfoSpecies(spuri);
				// incluyo también el indice
				spinfo.indice = 0;
				spinfo.indentspace = '';
				// añado el objeto SÓLO SI TIENE INDIVIDUOS Y NO ES DE txup23
				if (spinfo.allindivs > 0 && !spuri.startsWith(config.prefixes.txup23))
					btaxainfo.push(spinfo);
			}
		
			// Sort by 'label' in descending order
			btaxainfo.sort((a, b) => b.label.localeCompare(a.label));
			// Sort by calculated value in descending order
			btaxainfo.sort((a, b) => b.allindivs - a.allindivs);
			//btaxainfo.sort((a, b) => +b.nclasses*100 + +b.allindivs - (+a.nclasses*100 + +a.allindivs) );
		
			// generate the mark-up
			const content = Mustache.render(taxonesBlockTemplate, btaxainfo);
			
			// pongo el contenido
			divnav.innerHTML = content;	

			// HANDLERS
			// handler de seleccionar taxón
			document.querySelectorAll('.bot_sel_taxon').forEach(function(element) {
				element.addEventListener('click', handlerSeleccionarTaxon);
			});
			// handler de expandir taxón
			document.querySelectorAll('.bot_expandir_taxon').forEach(function(element) {
				element.addEventListener('click', handlerExpandTaxon);
			});
			// handler de showmore
			document.querySelectorAll('.showmore').forEach(function(element) {
				element.addEventListener('click', handlerShowmore);
			});
		}
	}
	else // esconder el bloque de contenido de los taxones
		divnav.classList.add("d-none");
}



//////////////////////
// HANDLER SUGERENCIAS
//////////////////////
function sugeTaxones(entrada) {
	let sugerencias = [];
	// sólo actúo si la entrada no es una cadena vacía
	if (entrada.length > 0) {
		// obtengo las uris de los taxones ordenados alfabéticamente
		const txuris = Object.keys(Datos.taxones).sort();
		// evalúo cada especie si vale
		for (let txuri of txuris) {
			// obtengo etiqueta de la especie (según Sesion.nomci)
			const labesp = getTaxonLabel(txuri, Sesion.nomci);
			// si coincide, a las sugerencias
			if (indexOfNormalized(labesp, entrada) > -1)
				sugerencias.push(txuri);
		}
	}
	return sugerencias;
}
function renderSugeTaxones(entrada, sugerencias) {
	// preparo sugerencias
	let sinfo = {};
	sinfo.sugerencias = [];
		
	// obtengo las sugerencias si la entrada no está vacía
	if (sugerencias.length == 0)
		sinfo.nosugerencias = true;
	else {
		for (let suge of sugerencias) {
			// obtengo información del objeto para formatear
			let spinfo = getInfoSpecies(suge);
			// índice en el que hubo match
			const ind = indexOfNormalized(spinfo.label, entrada);
			// formateo el nombre a mostrar con negritas
			spinfo.labelshown = "";
			if (ind > 0)
				spinfo.labelshown += spinfo.label.substr(0, ind);
			spinfo.labelshown += "<strong>" + spinfo.label.substr(ind, entrada.length) + "</strong>"
			spinfo.labelshown += spinfo.label.substr(ind + entrada.length);			
			// añado el objeto SÓLO SI TIENE INDIVIDUOS Y NO ES DE txup23
			if (spinfo.allindivs > 0 && !suge.startsWith(config.prefixes.txup23))
				sinfo.sugerencias.push(spinfo);
		}
	}
	
	// ordeno sugerencias por número de individuos y subclases
	sinfo.sugerencias.sort((a, b) => b.allindivs - a.allindivs);
	//sinfo.sugerencias.sort((a, b) => +b.nclasses*100 + +b.allindivs - (+a.nclasses*100 + +a.allindivs) );
	
	// corto número de sugerencias
	sinfo.sugerencias = sinfo.sugerencias.slice(0, config.numsugs);
	
	// muestro sugerencias
	const cont = Mustache.render(sugeTaxonesTemplate, sinfo);
	document.getElementById("sugetaxones").innerHTML = cont;
			
	// handler de los botones de sugerencias
	document.querySelectorAll('.bot_suge_taxon').forEach(function(element) {
		element.addEventListener('click', handlerSeleccionarTaxon);
	});
	
	// inicializo focus
	Sesion.txfocus = -1;
}
function ajustarTaxonfocus() {
	// Sesion.txfocus = 0; => cajetín entrada
	// Sesion.txfocus = i; => num de sugerencia
	
	// array de sugerencias que no están deshabilitadas
	const enabledsuges = Array.from(document.getElementById('sugetaxones').children).filter(child => !child.disabled);
	
	// obtengo número de sugerencias que no están deshabilitadas
	const ns = enabledsuges.length;
	// reajusto índice del focus si hace falta
	if (ns == 0) Sesion.txfocus = -1;
	else if (Sesion.txfocus >= ns) Sesion.txfocus = 0;
	else if (Sesion.txfocus < 0) Sesion.txfocus = ns -1;
	// y ahora las cosas visuales
	for (const es of enabledsuges) 
		es.classList.remove('active');
	if (Sesion.txfocus >= 0)
		enabledsuges[Sesion.txfocus].classList.add('active');
}


/////////////////////////////
// HANDLER NAVEGACIÓN TAXONES
/////////////////////////////
function handlerExpandTaxon(event) {
    const icon = event.currentTarget.querySelector("i");
    const div = event.currentTarget.closest(".taxon");

    if (event.currentTarget.classList.contains("active")) { // colapsar
        // desactivo botón
        event.currentTarget.classList.remove("active");
        // cambio el icono
        icon.classList.remove("bi-chevron-down");
        icon.classList.add("bi-chevron-right");

        // itero para quitar los elementos de la lista
        const indice = +div.getAttribute("indice");
        let nextDiv = div.nextElementSibling;
        while (nextDiv && +nextDiv.getAttribute("indice") > indice) {
            const temp = nextDiv.nextElementSibling;
            nextDiv.remove();
            nextDiv = temp;
        }
    } 
	else { // expandir
        // activo botón
        event.currentTarget.classList.add("active");
        // cambio el icono
        icon.classList.remove("bi-chevron-right");
        icon.classList.add("bi-chevron-down");
		
        // obtengo URI de la clase y preparo el indent
        const spuri = div.querySelector(".bot_sel_taxon").getAttribute("spuri");
        const newIndice = +div.getAttribute("indice") + 1;
        let indentSpace = "&nbsp;".repeat(newIndice * 4);

        // generar objeto auxiliar para la plantilla
		let scobj = [];
		for (let subspuri of Datos.taxones[spuri].subclasses) {
			// obtengo información del objeto para formatear
			let subspinfo = getInfoSpecies(subspuri);
			// incluyo también el indent
			subspinfo.indice = newIndice;
			subspinfo.indentspace = indentSpace;
			// añado el objeto SÓLO SI TIENE INDIVIDUOS Y NO ES DE txup23
			if (subspinfo.allindivs > 0 && !subspuri.startsWith(config.prefixes.txup23))
				scobj.push(subspinfo);
		}
		
		// sort elements
		scobj.sort((a, b) => b.allindivs - a.allindivs);
		//scobj.sort((a, b) => +b.nclasses*100 + +b.allindivs - (+a.nclasses*100 + +a.allindivs) );
		
		// show more button
		if (scobj.length > config.hidemax) {
			scobj.splice(config.hidebegin, 0, { "botonesconder" : true, "indice" : newIndice, "indentspace" : indentSpace+"&nbsp;&nbsp;&nbsp;&nbsp;" });
			for (let ind = config.hidebegin + 1; ind < scobj.length; ind++)
				scobj[ind].esconder = true;						
		}						

		// generate content and add	to the DOM
		const newContent = Mustache.render(taxonesBlockTemplate, scobj);	
        div.insertAdjacentHTML('afterend', newContent);

        // handler de seleccionar taxón
        document.querySelectorAll(".bot_sel_taxon").forEach(button => {
            button.removeEventListener('click', handlerSeleccionarTaxon);
            button.addEventListener('click', handlerSeleccionarTaxon);
        });
		
		// recreate handlers of the expand/collapse buttons
        document.querySelectorAll(".bot_expandir_taxon").forEach(button => {
            button.removeEventListener('click', handlerExpandTaxon);
            button.addEventListener('click', handlerExpandTaxon);
        });

		// recreate handlers of the showmore buttons
        document.querySelectorAll(".showmore").forEach(button => {
            button.addEventListener('click', handlerShowmore);
        });
	}
}
function handlerShowmore(event) {
    const div = event.currentTarget.closest(".taxon");
    const indice = +div.getAttribute("indice");
	// show elements
    let aux = div.nextElementSibling;
    while (aux && +aux.getAttribute("indice") === indice && aux.classList.contains("d-none")) {
        aux.classList.remove("d-none");
        aux.classList.add("d-flex");
        aux = aux.nextElementSibling;
    }
    // remove show more button
    div.remove();
}


// para formatear las especies (ahora tengo en cuenta versión inventario)
function getInfoSpecies(spuri) {
	// recupero especie
	const sp = Datos.taxones[spuri];
	// el objeto a devolver
	let spinfo = {};
	// incluyo la uri
	spinfo.uri = spuri;
	// etiqueta especie
	spinfo.label = getTaxonLabel(spuri, Sesion.nomci);
	spinfo.nc = Sesion.nomci;
	// info número de clases SÓLO SI TIENE INDIVIDUOS Y NO ES DE txup23
	spinfo.nclasses = 0;
	for (let suburi of Datos.taxones[spuri].subclasses) {
		if (Datos.taxones[suburi] && Datos.taxones[suburi].indivs[Sesion.estado.ifn].countALL > 0
				&& !suburi.startsWith(config.prefixes.txup23))
			spinfo.nclasses++;
	}
	if (spinfo.nclasses == 0)
		spinfo.nosubclasses = true;			
	// info individuos
	spinfo.allindivs = sp.indivs[Sesion.estado.ifn].countALL;
	if (spinfo.allindivs > 1000000)
		spinfo.nindivs = "+" + Math.floor(+spinfo.allindivs/1000000) + "M";
	else if (spinfo.allindivs > 1000)
		spinfo.nindivs = "+" + Math.floor(+spinfo.allindivs/1000) + "K";
	else
		spinfo.nindivs = spinfo.allindivs;
	// devuelvo el objeto
	return spinfo;
}



//////////////////////////
// HANDLER SELECCIÓN TAXÓN
//////////////////////////
function handlerSeleccionarTaxon(event) {
	// obtengo uri del taxon
	const turi = event.currentTarget.getAttribute("spuri");
	
	// invoco directamente el handler del botón "bot_taxones" para cerrar el collapsible
	handlerFiltrarTaxon();
		
	// vamos a la selección del taxón
	tratarSeleccionTaxon(turi);
}
function tratarSeleccionTaxon(turi) {
	// compruebo si la tenía
	if (!Sesion.taxones.includes(turi)) { // no estaba
		// si supero el número de especies filtradas no permito filtrar más
		if (Sesion.taxones.length >= config.maxTaxonFilters) {
			// aviso con un toast de que hay muchos taxones...
			document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
			document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.tooManyTaxons);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
		}
		else { // a guardar			
			// mando evento de filtro de taxón a GA		
			sendEvent( 'select_content', { content_type: 'taxon_filter', content_id: turi } );
	
			// logging
			console.log("Selección taxón " + turi);
			console.time("Selección taxón");
	
			// guardo taxón
			Sesion.taxones.push(turi);
			Sesion.taxonesCorrExpuris.push( correspondenciaTaxonMulti(Datos.taxones[turi].expuris, "ifn3") );
			
			// reajusto URL, pero no recargo
			history.replaceState(Sesion.estado, "", obtenerURL());
			
			// visualización filtros de taxón
			visualizarFiltrosTaxon();			
				
			// actualización colores y popups parcelas
			const puris = Object.keys(Sesion.parPintadas);
			ajustarColorParcelas(puris);
			ajustarPopupsParcelas(puris);
			
			// actualización colores y popups árboles
			const pauris = Object.keys(Sesion.parcarbPintadas);
			ajustarColorArboles(pauris);
			ajustarPopupsArboles(pauris);
				
			// actualización colores y popups provincias
			ajustarColorProvincias();
			ajustarPopupsProvincias();
						
			// actualización colores y popups teselas forestales
			const turis = Object.keys(Sesion.tesPintadas);
			ajustarColorTeselas(turis, false);
			ajustarPopupsTeselas(turis, false);
			
			console.timeEnd("Selección taxón");
		}
	}
	else {	// si estaba pongo otro toast
		document.getElementById("mitostadaStrong").innerHTML = getLiteral(dict.title);
		document.getElementById("mitostadaBody").innerHTML = getLiteral(dict.taxonAlreadyIncluded);
		const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
		tostada.show();
	}
}


//////////////////////////////
// HANDLER AJUSTE FILTRO TAXÓN
//////////////////////////////
function handlerAjustarFiltroTaxon() {
	// defino slids
	const slids = [	"nt", "ba", "vwb", "vwob" ];
	//const slids = [	"numberTreesHa", "basalAreaM2byHa", "volumeWithBarkM3byHa", "volumeWithoutBarkM3byHa", "sampledTrees" ];
	// referencia al iel para actualizar el icono luego...
	const iel = this.querySelector('i');
	// recupero el taxón (treeUri en este caso)
	const tx = this.getAttribute('turi')
	// recupero el filtro (si lo hay)
	let txfilt = Sesion.taxonesFiltros[tx];
	// configuro modal
	let txlab = Sesion.nomci? '<i>Plantae</i>' : getLiteral(dict.plants);
	if (tx !== config.treeUri)
		txlab = getTaxonLabel(tx, Sesion.nomci, true);
	const txobj = { txname: txlab };
	// para cada slid...
	for (const slid of slids) {
		txobj[slid+'min'] = txfilt && txfilt[slid]? txfilt[slid].min : 0;
		txobj[slid+'max'] = txfilt && txfilt[slid]? txfilt[slid].max : config.maxValuesPlot[slid];
	}
	// preparo cadenas
	txobj.numbertreesHA = getLiteral(dict.numbertreesHA);
	txobj.basalareaM2HA = window.innerWidth < 600? getLiteral(dict.basalareaM2HAmini) : getLiteral(dict.basalareaM2HA);
	txobj.volumewithbarkM3HA = window.innerWidth < 600? getLiteral(dict.volumewithbarkM3HAmini) : getLiteral(dict.volumewithbarkM3HA);
	txobj.volumewithoutbarkM3HA = window.innerWidth < 600? getLiteral(dict.volumewithoutbarkM3HAmini) : getLiteral(dict.volumewithoutbarkM3HA);
	// obtengo body del modal	
	const modalbody = Mustache.render(filterPlotModalTemplate, txobj);			
	configurarModal( { lg: false }, 
		getLiteral(dict.plotfilter), modalbody, footerFilterPlot);
	// muestro modal
	const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
	mimodal.show();			
	// creo sliders
	for (const slid of slids) {
		const slel = document.getElementById(slid);
		noUiSlider.create(slel, {
			start: [ txobj[slid+'min'], txobj[slid+'max']],
			step: 1,
			connect: true,
			range: {
				'min': 0,
				'max': config.maxValuesPlot[slid]
			}
		});
		// actualizo inputs
		slel.noUiSlider.on('update', function (values, handle) {
			const vmin = Math.round(values[0]);
			const vmax = Math.round(values[1]);
			document.getElementById(slid+'-min').value = vmin;
			document.getElementById(slid+'-max').value = vmax;
		});
		// listener min
		document.getElementById(slid+'-min').addEventListener('change', function(event) {
			const val = event.target.value;
			if (val === "") // entrada extraña, recupero valor anterior
				this.value = Math.round(slel.noUiSlider.get()[0]);
			else // actualización slider
				slel.noUiSlider.set([val, null]);
		});
		// listener max
		document.getElementById(slid+'-max').addEventListener('change', function(event) {
			const val = event.target.value;
			if (val === "") // entrada extraña, recupero valor anterior
				this.value = Math.round(slel.noUiSlider.get()[1]);
			else // actualización slider
				slel.noUiSlider.set([null, val]);
		});
	}
	// listener	al botón de aplicar filtro
	document.getElementById('applyFilter').addEventListener('click', function() {
		// preparo filtro
		txfilt = {};
		let hayalgo = false;
		// reviso uno a uno de los sliders
		for (const slid of slids) {
			const slel = document.getElementById(slid);
			const values = slel.noUiSlider.get();
			if (Math.round(values[0]) != 0 || Math.round(values[1]) != config.maxValuesPlot[slid]) {
				txfilt[slid] = {
					'min': Math.round(values[0]),
					'max': Math.round(values[1])
				};
				hayalgo = true;
			}
		}
		// guardo o borro el filtro y ajusto el icono de filtrar
		if (hayalgo) {
			Sesion.taxonesFiltros[tx] = txfilt;
			iel.classList.remove('bi-filter-circle-fill');
			iel.classList.add('bi-filter-circle');
		}
		else {
			delete Sesion.taxonesFiltros[tx];
			iel.classList.add('bi-filter-circle-fill');
			iel.classList.remove('bi-filter-circle');
		}
		
		// actualizo la URL
		history.replaceState(Sesion.estado, "", obtenerURL());

		// actualización colores parcelas y popups
		const puris = Object.keys(Sesion.parPintadas);
		ajustarColorParcelas(puris);
		ajustarPopupsParcelas(puris); // esto es por marcar en rojo los parámetros que no se cumplen
		
		// mando evento GA
		sendEvent( 'select_content', { content_type: 'apply_filter', content_id: tx, set: hayalgo } );
	});
	// listener	al botón de resetear filtro
	document.getElementById('resetFilter').addEventListener('click', function() {
		// borro el filtro y ajusto el icono de filtrar
		delete Sesion.taxonesFiltros[tx];
		iel.classList.add('bi-filter-circle-fill');
		iel.classList.remove('bi-filter-circle');
		
		// actualizo la URL
		history.replaceState(Sesion.estado, "", obtenerURL());

		// actualización colores parcelas y popups
		const puris = Object.keys(Sesion.parPintadas);
		ajustarColorParcelas(puris);
		ajustarPopupsParcelas(puris); // esto es por marcar en rojo los parámetros que no se cumplen
		
		// mando evento GA
		sendEvent( 'select_content', { content_type: 'reset_filter', content_id: tx } );
	});
}


///////////////////////////////////////////////////
// USO ONTOLOGÍA UP23 PARA EXTRAER CORRESPONDENCIAS
///////////////////////////////////////////////////
// se usa en cargarURL para mapear un taxón de un ifn a otro ifnobj
function correspondenciaTaxon(turi, ifnobj) {
	// de momento sólo devuelvo una o null
	if (!Datos.taxones[turi])
		return null;
	// caso trivial, nada que mapear
	if (turi.startsWith(config.prefixes.txtop) || turi.startsWith(config.prefixes["tx"+ifnobj]))
		return turi;
	// hay que hacer mapeo, analizo las superclases y busco taxón txup23
	const txup23 = Datos.taxones[turi].superclasses.find((supuri) => supuri.startsWith(config.prefixes.txup23));
	// si no hay txup23, nada que hacer
	if (!txup23) 
		return null;
	// analizo los mapeos de txup23 para ifnobj
	const txifnobj = Datos.taxones[txup23].subclasses.filter((suburi) => suburi.startsWith(config.prefixes["tx"+ifnobj]));
	if (txifnobj.length == 0) // sin mapeos
		return null;
	else if (txifnobj.length == 1) // mapeo 1-1, lo devuelvo
		return txifnobj[0];
	else {
		// caso complicado, se mapea a varios taxones
		// devuelvo el primer taxón padre de tipo txtop de txup23
		return Datos.taxones[txup23].superclasses.find((supuri) => supuri.startsWith(config.prefixes.txtop));
	}	
}
// se usa en las teselas para mapear una lista de taxones de un ifn a otra lista de taxones de ifnobj
function correspondenciaTaxonMulti(turis, ifnobj) {
	let oturis = []; // la respuesta
	for (let turi of turis) {
		if (!Datos.taxones[turi])
			continue;
		
		// caso trivial, nada que mapear
		if (turi.startsWith(config.prefixes.txtop) || turi.startsWith(config.prefixes["tx"+ifnobj])) {
			oturis.push(turi);
			continue;
		}
		
		// hay que hacer mapeo, analizo las superclases y busco taxón txup23
		const txup23 = Datos.taxones[turi].superclasses.find((supuri) => supuri.startsWith(config.prefixes.txup23));
		// si no hay txup23, nada que hacer
		if (!txup23) 
			continue;
		// analizo los mapeos de txup23 para ifnobj
		const txifnobj = Datos.taxones[txup23].subclasses.filter((suburi) => suburi.startsWith(config.prefixes["tx"+ifnobj]));
		if (txifnobj.length == 0) // sin mapeos
			continue;
		else if (txifnobj.length == 1) // mapeo 1-1, lo devuelvo
			oturis.push(txifnobj[0]);
		else // incluyo la lista de taxones objetivo
			oturis = oturis.concat(txifnobj);
	}
	return oturis;
}

function getTaxonLabel(turi, nomci, incluiri) {
	let txlab = uriToLiteral(turi);
	if (Datos.taxones[turi]) {
		txlab = firstUppercase(getLiteral(Datos.taxones[turi].vulgarName, txlab));
		if (nomci) {
			txlab = firstUppercase(getLiteral(Datos.taxones[turi].scientificName, txlab));
			if (incluiri)
				txlab =  '<i>' + txlab + '</i>';
		}
	}
	return txlab;
}

export { getMoreSpecificTaxon, sumMeasureTaxon, sumPropInfoTaxon, handlerNombreCientifico, handlerFiltrarTaxon, handlerAjustarFiltroTaxon,
	visualizarFiltrosTaxon, correspondenciaTaxon, correspondenciaTaxonMulti, mostrarInfoTaxon, getTaxonLabel };